import config from './config';

export const loadBackofficeCustomizer = async () => {
    // The package initializes the global legacy config with its production URLs.
    // Restore this Backoffice environment before a scene can make any requests.
    const customizer = await import('@zakeke/zakeke-customizer-react');
    Object.assign(window.Zakeke.config, {
        baseApiUrl: config.apiUrl,
        baseScenesApiUrl: config.apiUrl,
        baseImagesUploadApiUrl: config.imagesUploadApiUrl
    });
    return customizer;
};
